import { getUserProducts } from '@/utils/authorization/user-products'
import { isUserAllowed } from '@/utils/authorization/page-access'
import * as tabAccessRules from '@/rules/tab-access'
import { RouteName } from '@/base/constants/route'
import { PRODUCTS } from '@/base/constants/authorization'

/**
 * Navigation guard for the ASO Report page.
 *
 * This guard is implemented for navigating the ASO Report page opening tab.
 * Enterprise users (those with the ASO_BUSINESS product) should be redirected to the "All Ranked Keywords" tab,
 * Self-served package users should be redirected to “Tracked Keywords” tab in the ASO Report page.
 *
 * @param {object} to - The destination route object.
 * @param {object} from - The current route object.
 * @param {Function} next - The 'next' function used for route navigation.
 * @returns {void}
 */
export async function asoReportGuard(to, _from, next) {
  if (to.name == RouteName.ASO_INTELLIGENCE_PERFORMANCE_ASO_REPORT) {
    const userProducts = await getUserProducts()
    const hasAsoBusiness = userProducts.some(({ name }) => name == PRODUCTS.ASO_BUSINESS)
    const isAllowedAllRankedTab = isUserAllowed({
      requiredAccess: tabAccessRules.accessAsoReportAllRankedKeywordsTabRule,
      userActiveProducts: userProducts,
    })

    if (hasAsoBusiness && isAllowedAllRankedTab) {
      return next({ name: RouteName.ASO_INTELLIGENCE_PERFORMANCE_ASO_REPORT_ALL_RANKED_KEYWORDS })
    }
    else {
      return next({ name: RouteName.ASO_INTELLIGENCE_PERFORMANCE_ASO_REPORT_TRACKED_KEYWORDS })
    }
  }

  next()
}
